<template>
  <div>
    <h4>{{ title }}</h4>
    <div class="media-description" v-if="hasVideos">
      <template v-for="(videoUrl, index) in contentVideos">
        <span class="video-container" v-show="index <= visibleVideoIndex || showMore" :key="index">
          <youtube-wrapper :url="videoUrl" />
        </span>
      </template>
    </div>
    <base-button
      type="button"
      class="border-primary-button"
      background-color="transparent"
      background-color-hover="#44A9E5"
      text-color="#44A9E5"
      border-color="#44A9E5"
      @click="showMoreVideos"
    >
      {{ showMore ? 'See Less' : 'Learn More' }}
    </base-button>
  </div>
</template>

<script>
import BaseButton from '@/components/base-button';
import YoutubeWrapper from '@/components/youtube-wrapper';

export default {
  name: 'VideoBox',
  components: {
    YoutubeWrapper,
    BaseButton,
  },
  props: {
    content: {
      type: Object,
      default() {
        return {};
      },
    },
    visibleVideos: {
      type: Number,
      default: 1,
      validator(propValue) {
        return propValue > 0;
      },
    },
  },
  data() {
    return {
      showMore: false,
    };
  },
  computed: {
    title() {
      return this.content.name || '';
    },
    contentVideos() {
      return Object.values(this.content.videos).filter((video) => Boolean(video)) || [];
    },
    hasVideos() {
      return Object.keys(this.contentVideos).length > 0;
    },
    visibleVideoIndex() {
      return this.visibleVideos - 1;
    },
  },
  methods: {
    showMoreVideos() {
      this.showMore = !this.showMore;
    },
  },
};
</script>

<style scoped lang="scss">
.video-container {
  display: inline-block;
  width: 100%;
  height: 100%;
}

@media (max-width: 768px) {
  .media-description > div {
    height: 220px;
    margin-bottom: 1rem;
  }
}
</style>
